/* eslint-disable max-len */
import React from 'react';

import { colors } from 'theme/colors';

export const InboxIcon: React.FunctionComponent<{ notDismissedNotificationsCount: number }> = ({
  notDismissedNotificationsCount,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="22" viewBox="0 0 26 20" fill="none">
    <g>
      <path
        d="M19.8167 6.66667L18.4667 1.26667C18.2833 0.516667 17.6167 0 16.85 0H3.15C2.38333 0 1.71667 0.516667 1.53333 1.26667L0.183333 6.66667L0 7.36667V15.8333C0 16.75 0.75 17.5 1.66667 17.5H18.3333C19.25 17.5 20 16.75 20 15.8333V7.36667L19.8167 6.66667ZM4.45 1.66667H15.55C16.3167 1.66667 16.9833 2.18333 17.1667 2.93333L17.9667 6.15C18.0333 6.41667 17.8333 6.66667 17.5667 6.66667H15.4167C14.5 6.66667 13.75 7.41667 13.75 8.33333V10.0333C13.75 10.5 13.3833 10.8667 12.9167 10.8667H7.08333C6.61667 10.8667 6.25 10.5 6.25 10.0333V8.33333C6.25 7.41667 5.5 6.66667 4.58333 6.66667H2.43333C2.16667 6.66667 1.96667 6.41667 2.03333 6.15L2.83333 2.93333C3.01667 2.18333 3.68333 1.66667 4.45 1.66667ZM16.6667 15.8333H3.33333C2.41667 15.8333 1.66667 15.0833 1.66667 14.1667V8.75C1.66667 8.51667 1.85 8.33333 2.08333 8.33333H4.16667C4.4 8.33333 4.58333 8.51667 4.58333 8.75V10.8667C4.58333 11.7833 5.33333 12.5333 6.25 12.5333H13.75C14.6667 12.5333 15.4167 11.7833 15.4167 10.8667V8.75C15.4167 8.51667 15.6 8.33333 15.8333 8.33333H17.9167C18.15 8.33333 18.3333 8.51667 18.3333 8.75V14.1667C18.3333 15.0833 17.5833 15.8333 16.6667 15.8333Z"
        fill={colors.ui.border.light}
      />
      <path
        d="M11.334 15.0166H8.66732C8.20065 15.0166 7.83398 14.65 7.83398 14.1833C7.83398 13.7166 8.20065 13.35 8.66732 13.35H11.334C11.8007 13.35 12.1673 13.7166 12.1673 14.1833C12.1673 14.65 11.8007 15.0166 11.334 15.0166Z"
        fill={colors.ui.border.light}
      />
    </g>
    <defs>
      <clipPath id="clip0_14504_222941">
        <rect width="20" height="17.5" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
    {notDismissedNotificationsCount > 0 ? (
      <g>
        <ellipse stroke={colors.common.white} fill={colors.error.main} rx="7px" ry="7px" cx="18px" cy="7px" />
        <text
          x="18.19454"
          y="4.7"
          textAnchor="middle"
          dominantBaseline="middle"
          alignmentBaseline="middle"
          stroke={colors.common.white}
          strokeWidth="1px"
          dy=".3em"
          fontSize="9px"
          fontWeight={300}
        >
          {notDismissedNotificationsCount > 9 ? '9+' : String(notDismissedNotificationsCount)}
        </text>
      </g>
    ) : null}
  </svg>
);

export const ActiveInboxIcon: React.FunctionComponent<{ notDismissedNotificationsCount: number }> = ({
  notDismissedNotificationsCount,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="22" viewBox="0 0 26 20" fill="none">
    <path
      d="M15.8333 8.33333C15.6 8.33333 15.4167 8.51667 15.4167 8.75V10.85C15.4167 11.7833 14.6667 12.5167 13.75 12.5167H6.25C5.33333 12.5167 4.58333 11.7833 4.58333 10.85V8.75C4.58333 8.51667 4.4 8.33333 4.16667 8.33333H0V15.8333C0 16.75 0.75 17.5 1.66667 17.5H18.3333C19.25 17.5 20 16.75 20 15.8333V8.33333H15.8333ZM11.3333 15.8333H8.66667C8.21667 15.8333 7.83333 15.4667 7.83333 15C7.83333 14.5333 8.21667 14.1667 8.66667 14.1667H11.3333C11.7833 14.1667 12.1667 14.55 12.1667 15C12.1667 15.45 11.7833 15.8333 11.3333 15.8333Z"
      fill="white"
    />
    <path
      d="M19.8169 6.66667H15.4169C14.5003 6.66667 13.7503 7.41667 13.7503 8.33333V10.0167C13.7503 10.4833 13.3836 10.85 12.9169 10.85H7.08359C6.61693 10.85 6.25026 10.4833 6.25026 10.0167V8.33333C6.25026 7.41667 5.50026 6.66667 4.58359 6.66667H0.183594L1.53359 1.26667C1.71693 0.516667 2.38359 0 3.15026 0H16.8503C17.6169 0 18.2836 0.516667 18.4669 1.26667L19.8169 6.66667Z"
      fill="white"
    />

    {notDismissedNotificationsCount > 0 ? (
      <g>
        <ellipse stroke={colors.common.white} fill={colors.error.main} rx="7px" ry="7px" cx="18px" cy="7px" />
        <text
          x="18.19454"
          y="4.7"
          textAnchor="middle"
          dominantBaseline="middle"
          alignmentBaseline="middle"
          stroke={colors.common.white}
          strokeWidth="1px"
          dy=".3em"
          fontSize="9px"
          fontWeight={300}
        >
          {notDismissedNotificationsCount > 9 ? '9+' : String(notDismissedNotificationsCount)}
        </text>
      </g>
    ) : null}
  </svg>
);

export const AllInboxIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g clipPath="url(#clip0_14025_73980)">
      <path
        d="M5.25 6H2.25C1.83 6 1.5 5.67 1.5 5.25V2.25C1.5 1.83 1.83 1.5 2.25 1.5H5.25C5.67 1.5 6 1.83 6 2.25V5.25C6 5.67 5.67 6 5.25 6ZM0 1.5V6C0 6.84 0.66 7.5 1.5 7.5H6C6.84 7.5 7.5 6.84 7.5 6V1.5C7.5 0.66 6.84 0 6 0H1.5C0.66 0 0 0.66 0 1.5Z"
        fill="white"
        fillOpacity="0.56"
      />
      <path
        d="M17.25 3.08997H9.75C9.33 3.08997 9 2.75997 9 2.33997C9 1.91997 9.33 1.58997 9.75 1.58997H17.25C17.67 1.58997 18 1.91997 18 2.33997C18 2.75997 17.67 3.08997 17.25 3.08997Z"
        fill="white"
        fillOpacity="0.56"
      />
      <path
        d="M17.25 6.08997H9.75C9.33 6.08997 9 5.75997 9 5.33997C9 4.91997 9.33 4.58997 9.75 4.58997H17.25C17.67 4.58997 18 4.91997 18 5.33997C18 5.75997 17.67 6.08997 17.25 6.08997Z"
        fill="white"
        fillOpacity="0.56"
      />
      <path
        d="M5.25 16.5H2.25C1.83 16.5 1.5 16.17 1.5 15.75V12.75C1.5 12.33 1.83 12 2.25 12H5.25C5.67 12 6 12.33 6 12.75V15.75C6 16.17 5.67 16.5 5.25 16.5ZM0 12V16.5C0 17.34 0.66 18 1.5 18H6C6.84 18 7.5 17.34 7.5 16.5V12C7.5 11.16 6.84 10.5 6 10.5H1.5C0.66 10.5 0 11.16 0 12Z"
        fill="white"
        fillOpacity="0.56"
      />
      <path
        d="M17.25 13.59H9.75C9.33 13.59 9 13.26 9 12.84C9 12.42 9.33 12.09 9.75 12.09H17.25C17.67 12.09 18 12.42 18 12.84C18 13.26 17.67 13.59 17.25 13.59Z"
        fill="white"
        fillOpacity="0.56"
      />
      <path
        d="M17.25 16.59H9.75C9.33 16.59 9 16.26 9 15.84C9 15.42 9.33 15.09 9.75 15.09H17.25C17.67 15.09 18 15.42 18 15.84C18 16.26 17.67 16.59 17.25 16.59Z"
        fill="white"
        fillOpacity="0.56"
      />
    </g>
    <defs>
      <clipPath id="clip0_14025_73980">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ActiveAllInboxIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
    <g clipPath="url(#clip0_14025_73950)">
      <path
        d="M7.5 1.5V6C7.5 6.84 6.81 7.5 6 7.5H1.5C0.66 7.5 0 6.84 0 6V1.5C0 0.69 0.66 0 1.5 0H6C6.81 0 7.5 0.69 7.5 1.5Z"
        fill="white"
      />
      <path
        d="M17.28 3.08997H9.75C9.33 3.08997 9 2.75997 9 2.33997C9 1.91997 9.33 1.58997 9.75 1.58997H17.28C17.7 1.58997 18.03 1.91997 18.03 2.33997C18.03 2.75997 17.7 3.08997 17.28 3.08997Z"
        fill="white"
      />
      <path
        d="M17.28 6.08997H9.75C9.33 6.08997 9 5.75997 9 5.33997C9 4.91997 9.33 4.58997 9.75 4.58997H17.28C17.7 4.58997 18.03 4.91997 18.03 5.33997C18.03 5.75997 17.7 6.08997 17.28 6.08997Z"
        fill="white"
      />
      <path
        d="M7.5 12V16.5C7.5 17.34 6.81 18 6 18H1.5C0.66 18 0 17.34 0 16.5V12C0 11.19 0.66 10.5 1.5 10.5H6C6.81 10.5 7.5 11.19 7.5 12Z"
        fill="white"
      />
      <path
        d="M17.28 13.59H9.75C9.33 13.59 9 13.26 9 12.84C9 12.42 9.33 12.09 9.75 12.09H17.28C17.7 12.09 18.03 12.42 18.03 12.84C18.03 13.26 17.7 13.59 17.28 13.59Z"
        fill="white"
      />
      <path
        d="M17.28 16.59H9.75C9.33 16.59 9 16.26 9 15.84C9 15.42 9.33 15.09 9.75 15.09H17.28C17.7 15.09 18.03 15.42 18.03 15.84C18.03 16.26 17.7 16.59 17.28 16.59Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_14025_73950">
        <rect width="18.03" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
